import { render, staticRenderFns } from "./TreasuryTransactionFloatBtns.vue?vue&type=template&id=3ad65788&"
import script from "./TreasuryTransactionFloatBtns.vue?vue&type=script&lang=js&"
export * from "./TreasuryTransactionFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports